import type {
    TaskTypePayload,
    TaskTypeResponse,
} from '@/types/apps/task-type.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

type TaskTypeListResponse = ApiResponse<PaginatedResult<TaskTypeResponse>>;

export class TaskTypeService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/task-check-type',
        detail: (id: string) => `/api/task-check-type/${id}`,
    };

    public index(params?: QueryParams): Promise<TaskTypeListResponse> {
        const finalParam = {
            ...params,
            includeProperties: 'TemplateCheck',
        };

        return this.apiClient.fetchApi(this.endpoints.base(), finalParam);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<TaskTypeResponse>> {
        const url = this.endpoints.detail(id);

        return this.apiClient.fetchApi(url, params);
    }

    public create(
        payload: TaskTypePayload
    ): Promise<ApiResponse<TaskTypeResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: TaskTypePayload
    ): Promise<ApiResponse<TaskTypeResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }
    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
